import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import DefaultButton from '../default-btn/DefaultButton';
import './FileInput.scss';

const FileInput = ({ handleFileSelect, locKey, ...props }) => {
  const fileInput = useRef();

  const onFileSelected = () => {
    const [file] = fileInput.current.files;
    file && handleFileSelect(file);
    fileInput.current.value = null;
  };

  const initFileInput = () => fileInput.current?.click();

  return (
    <div className="file-input-wrapper">
      <DefaultButton locKey={locKey} onClick={initFileInput} className="qau-file-input" />
      <input type="file" ref={fileInput} name="file-upload" data-testid="file-upload-input" onChange={onFileSelected} {...props} />
    </div>
  );
};

FileInput.propTypes = {
  locKey: PropTypes.string,
  handleFileSelect: PropTypes.func.isRequired,
};

export default FileInput;
